import axios from "axios";
import _ from "lodash";
import { saveStationList } from "./actions/faultForms";
import { setErrorMsg, setLoader, setSuccessMsg } from "./actions/Header";
import { tokenExpired } from "./actions/login";
import { S3 } from "./awsConfig";
import store from "./store";

const { dispatch, getState } = store;

const baseURL = process.env.REACT_APP_API_URL;
export const axiosInstance = axios.create({
  baseURL,
});

let bucketName = process.env.REACT_APP_BUCKET_NAME;

export const updatedAccessToken = () => {
  let headerObj = {
    authorizationToken: getState().tokenReducer.accessToken,
  };
  return headerObj;
};

const ServiceMethod = async (url, type, payload = {}) => {
  try {
    let response;
    dispatch(setLoader(true));
    if (_.isEmpty(payload)) {
      response = await axiosInstance[type](url, {
        headers: updatedAccessToken(),
      });
    } else {
      response = await axiosInstance[type](url, payload, {
        headers: updatedAccessToken(),
      });
    }
    dispatch(setLoader(false));
    if (response.data.statusCode == 200) {
      if (response.data.body.message) {
        dispatch(setSuccessMsg(response.data.body.message));
      }
      return response.data.body;
    } else {
      dispatch(setErrorMsg(response.data.body.message));
      return;
    }
  } catch (error) {
    dispatch(setLoader(false));

    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const removeFaultImage = async (url, type) => {
  try {
    dispatch(setLoader(true));

    let response = await axiosInstance[type](
      url,
      {},
      { headers: updatedAccessToken() }
    );

    dispatch(setLoader(false));
    if (response.data.statusCode == 200) {
      if (response.data.body.message) {
        dispatch(setSuccessMsg(response.data.body.message));
      }
      return response.data.body;
    } else {
      dispatch(setErrorMsg(response.data.body.message));
      return;
    }
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const updateCustomer = async (url, type, payload = {}) => {
  try {
    let response = await axiosInstance[type](url, payload, {
      headers: updatedAccessToken(),
    });
    dispatch(setLoader(false));
    if (response.data.statusCode == 200) {
      if (response.data.body.message) {
        dispatch(setSuccessMsg(response.data.body.message));
      }
      return response.data.body;
    } else {
      dispatch(setErrorMsg(response.data.body.message));
      return;
    }
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const getFaultStatus = async (url, type, data) => {
  try {
    let response = await axiosInstance[type](url, data);
    return response.data;
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const getDetailImage = async (imgPath) => {
  try {
    const objects = await S3.listObjects({
      Bucket: bucketName,
      Prefix: imgPath,
    }).promise();
    return Promise.all(
      objects.Contents.map(
        async (t) =>
          await S3.getSignedUrl("getObject", { Key: t.Key, Expires: 10000 })
      )
    ).then((photoUrl) => photoUrl?.[0] || "");
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const getStationList = async (url, type) => {
  try {
    let response = await axiosInstance[type](url);
    if (response.data.statusCode == 200) {
      dispatch(saveStationList(response.data.body));
    }
    return response;
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const submitFaultForms = async (url, type, data) => {
  try {
    dispatch(setLoader(true));
    let response = await axiosInstance[type](url, data);
    dispatch(setLoader(false));
    return response.data;
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
    return;
  }
};

const unSubscribe = async (url, type, body) => {
  try {
    dispatch(setLoader(true));
    let response = await axiosInstance[type](url, body);
    dispatch(setLoader(false));
    return response.data.body;
  } catch (error) {
    dispatch(setLoader(false));
    if (error.response?.status === 403) {
      dispatch(tokenExpired(true));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      dispatch(setErrorMsg(error.message));
    }
  }
};

export const services = {
  ServiceMethod,
  removeFaultImage,
  updateCustomer,
  getDetailImage,
  getFaultStatus,
  getStationList,
  submitFaultForms,
  unSubscribe,
};
